import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';

export default function getFileHashErrorMessage(message: string | undefined) {
  if (!message) return '';

  return (
    GLOBAL_ERROR_MESSAGE[message] ||
    `문서 검증 중 예상하지 못한 오류가 발생했습니다.\n잠시 후 다시 시도하거나, 아래 오류 내용을 고객센터로 문의해 주세요.`
  );
}
